// Families are the CMS 14-system ROS organs that map onto one ICD-10-CM chapter:
// https://www.cms.gov/outreach-and-education/medicare-learning-network-mln/mlnedwebguide/downloads/97docguidelines.pdf
// Code ranges are those chapter bounds from the CDC ICD-10-CM tabular/guidelines
// (eyes H00-H59 vs ear H60-H95; hematologic D50-D89 vs neoplasms C00-D49):
// https://www.cdc.gov/nchs/icd/icd-10-cm/files.html
// https://ftp.cdc.gov/pub/health_statistics/nchs/Publications/ICD10CM/2026/ICD-10-CM-October-2025-Guidelines.pdf
export const ICD10_DISPLAY_FAMILY_SORT_KEY = {
  eyes: 0,
  cardiovascular: 1,
  respiratory: 2,
  gastrointestinal: 3,
  genitourinary: 4,
  musculoskeletal: 5,
  neurologic: 6,
  endocrine: 7,
  hematologic: 8,
  psychiatric: 9,
  other: 10,
} as const

export type Icd10DisplayFamily = keyof typeof ICD10_DISPLAY_FAMILY_SORT_KEY

export function icd10CodeDisplayFamilySortKey(code: string): number {
  const compact = code.trim().toUpperCase().replaceAll('.', '')
  const letter = compact[0]
  const category = Number.parseInt(compact.slice(1, 3), 10)
  if (letter === undefined || !Number.isFinite(category)) {
    return ICD10_DISPLAY_FAMILY_SORT_KEY.other
  }

  if (letter === 'H') {
    return category <= 59
      ? ICD10_DISPLAY_FAMILY_SORT_KEY.eyes
      : ICD10_DISPLAY_FAMILY_SORT_KEY.other
  }
  if (letter === 'D') {
    return category >= 50 && category <= 89
      ? ICD10_DISPLAY_FAMILY_SORT_KEY.hematologic
      : ICD10_DISPLAY_FAMILY_SORT_KEY.other
  }

  switch (letter) {
    case 'I':
      return ICD10_DISPLAY_FAMILY_SORT_KEY.cardiovascular
    case 'J':
      return ICD10_DISPLAY_FAMILY_SORT_KEY.respiratory
    case 'K':
      return ICD10_DISPLAY_FAMILY_SORT_KEY.gastrointestinal
    case 'N':
      return ICD10_DISPLAY_FAMILY_SORT_KEY.genitourinary
    case 'M':
      return ICD10_DISPLAY_FAMILY_SORT_KEY.musculoskeletal
    case 'G':
      return ICD10_DISPLAY_FAMILY_SORT_KEY.neurologic
    case 'E':
      return ICD10_DISPLAY_FAMILY_SORT_KEY.endocrine
    case 'F':
      return ICD10_DISPLAY_FAMILY_SORT_KEY.psychiatric
    default:
      return ICD10_DISPLAY_FAMILY_SORT_KEY.other
  }
}

export function icd10CodesDisplayFamilySortKey(
  codes: readonly string[]
): number {
  if (codes.length === 0) {
    return ICD10_DISPLAY_FAMILY_SORT_KEY.other
  }
  return Math.min(...codes.map(icd10CodeDisplayFamilySortKey))
}
